import { render, staticRenderFns } from "./Navheader.vue?vue&type=template&id=22e8a82f&"
import script from "./Navheader.vue?vue&type=script&lang=js&"
export * from "./Navheader.vue?vue&type=script&lang=js&"
import style0 from "./Navheader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports